
export const COMMENTS_DEFAULT_SORT = 'comments/COMMENTS_DEFAULT_SORT';
export const COMMENTS_AVAILABLE_SORTING = 'comments/COMMENTS_AVAILABLE_SORTING';

export const commentsInitialState = {
  default_sort: 'newestFirst',
  availableSorting: [
    'mostKudosFirst',
    'newestFirst',
    'oldestFirst',
    'moderatorView',
  ],
};

export const changeDefaultSortAction = payload => ({ type: COMMENTS_DEFAULT_SORT, payload });

export const commentsReducer = (state = commentsInitialState, action) => {
  switch (action.type) {
  case COMMENTS_DEFAULT_SORT:
    return {
      ...state,
      default_sort: action.payload,
    };
  case COMMENTS_AVAILABLE_SORTING:
    return {
      ...state,
      availableSorting: action.payload,
    };    
  default:
    return state;
  }
};

export const selectDefaultSort = state => state.comments.default_sort;
export const selectAvailableSorting = state => state.comments.availableSorting;

//import {
//  loadComments,
//} from '../apis/comments';
//
//const FETCH_COMMENTS = 'FETCH_COMMENTS';
//
//export const commentsInitialState = {
//  commentslist: {},
//  can_comment: false,
//  comment_count: 0,
//  get_rate_limit: '',
//  default_sort: 'newestFirst',
//  available_sorts: [
//    'newestFirst',
//    'mostKudosFirst',
//    'oldestFirst',
//    'moderatorView',
//  ],
//};
//
//const mapKeys = arr => (arr || []).reduce((a, v) => ({ ...a, [v['id']]: v }), {});
//
//export const fetchComments = () => async dispatch => {
//  const response = await loadComments();
//  dispatch({ type: FETCH_COMMENTS, payload: response.data });
//};
//
//export const commentsReducer = (state = commentsInitialState, action) => {
//  switch (action.type) {
//  case FETCH_COMMENTS:
//    return {
//      ...state,
//      commentslist: mapKeys(action.payload.data.comments, 'id'),
//      can_comment: action.payload.summary.can_comment,
//      comment_count: action.payload.summary.comment_count,
//      get_rate_limit: action.payload.summary.get_rate_limit,
//    };
//  default:
//    return state;
//  }
//};
